module.exports = __webpack_public_path__ + "img/img4.d15881b0.png";